import * as React from 'react';
import useWindowSize from './useWindowSize';

/**
 * React Hook that returns the current window size
 * and report updates from the 'resize' window event
 *
 * @typedef {useIsMobile} useIsMobile
 * @property {number} isWider Window width judgment...
 * @returns {isWider} A value representing whether the width is greater than 768
 */

const useIsWiderThan = (width: number): boolean => {
    const { width: windowWidth } = useWindowSize();
    const [isWider, setIsWider] = React.useState(windowWidth > width);

    React.useEffect(() => {
        setIsWider(windowWidth > width);
    }, [windowWidth, width]);

    return isWider;
};

export default useIsWiderThan;
